/**
 * @description Maps simple locale codes to BCP 47 locale tags for Intl APIs
 * @param locale - Simple locale code (e.g., 'ro', 'en', 'de')
 * @returns BCP 47 locale tag (e.g., 'ro-RO', 'en-GB', 'de-DE')
 *
 * @example
 * mapLocaleToBCP47('ro') // returns 'ro-RO'
 * mapLocaleToBCP47('en') // returns 'en-GB'
 * mapLocaleToBCP47('de') // returns 'de-DE'
 * mapLocaleToBCP47('invalid') // returns 'en-GB' (fallback)
 */
export const mapLocaleToBCP47 = (locale: string): string => {
  const localeMap: Record<string, string> = {
    ro: 'ro-RO',
    en: 'en-GB',
    hu: 'hu-HU',
    de: 'de-DE',
    fr: 'fr-FR',
    it: 'it-IT',
    es: 'es-ES',
  };

  // Return mapped locale or fallback to 'en-GB' if not found
  return localeMap[locale] || 'en-GB';
};

